import { Component, inject, input } from '@angular/core';

import { defer } from 'rxjs';

import { CamTenantUrlDisplayerComponent } from '../../../../common/components/tenant-url-displayer/tenant-url-displayer.component';
import { CamQuotationsService } from '../../services/quotations.service';

@Component({
  imports: [CamTenantUrlDisplayerComponent],
  selector: 'cam-quotation-tenant-url-displayer',
  templateUrl: './quotation-tenant-url-displayer.component.html',
})
export class CamQuotationTenantUrlDisplayerComponent {
  private _quotationService = inject(CamQuotationsService);

  versionId = input.required<string>();

  display = input<'button' | 'icon'>('icon');

  route$ = this._quotationService.tenantRoute.get$();

  fetch$ = defer(() => this._quotationService.fetchVersionTenantRoute$(this.versionId()));
}
